import type { TileHeaderPropsType } from '../types';

const TileHeader = ({ title, subtitle }: TileHeaderPropsType) => (
  <div className="tile-header">
    <span className="tile-header-title">{title}</span>
    {subtitle && <span className="tile-header-subtitle">{subtitle}</span>}
  </div>
);

export default TileHeader;
